var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ni-app-header-wrapper columns"},[_c('h3',{staticClass:"column is-3"},[_vm._v("New Item Submission")])])}]

export { render, staticRenderFns }